import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Missing from './components/Missing';
import AdminPage from './components/AdminPage';
import { AdminProtectedRoute } from './utils/ProtectedRoutes'; // Koruma rotalarını içe aktar


function App() { 

  return (
    <>    
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />

        {/* Protected Routes for Admin */}
        <Route element={<AdminProtectedRoute />}> 
          <Route path="/admin" element={<AdminPage />} />

        </Route>
      
        {/* Catch All for Non-Existing Routes */}
        <Route path="*" element={<Missing />} />
      </Routes>
    </>
  );
}

export default App;
